import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges } from '@angular/core';
import { EventsService, StorageService, VariablesService } from '../../../shared/services';

@Component({
  selector: 'app-fifty-rupee-nudge',
  templateUrl: './fifty-rupee-nudge.component.html',
  styleUrls: ['./fifty-rupee-nudge.component.scss']
})
export class FiftyRupeeNudgeComponent implements OnInit {

  thank_you = false;
  nudge = true;
  @Output() emitAmount = new EventEmitter();
  @Input() amount: number;

  constructor(
    public eventService: EventsService,
    public variableService: VariablesService,
    public storageService: StorageService
  ) { }

  ngOnInit(): void {
  }

  showthankyou() {
    this.thank_you = true;
    this.emitAmount.emit(this.amount + 50);
    this.storageService.addSessionData('nudge', true);
    this.eventService.sendSystemEvent({
      eventName: 'nudge clicked'
    }).subscribe(_ => _);
    this.variableService.campaignType = 'nudge clicked';
    setTimeout(() => {
      this.thank_you = false;
      this.nudge = false;
    }, 3000);
  }

}
